import { ThemeOptions } from '@mui/material';

import * as MuiButtonBase from './MuiButtonBase';
import * as MuiFormControl from './MuiFormControl';
import * as MuiFormControlLabel from './MuiFormControlLabel';
import * as MuiFormLabel from './MuiFormLabel';
import * as MuiIconButton from './MuiIconButton';
import * as MuiInput from './MuiInput';
import * as MuiListItem from './MuiListItem';
import * as MuiListItemAvatar from './MuiListItemAvatar';
import * as MuiListItemButton from './MuiListItemButton';
import * as MuiListItemIcon from './MuiListItemIcon';
import * as MuiListItemText from './MuiListItemText';
import * as MuiListSubheader from './MuiListSubheader';
import * as MuiMenuItem from './MuiMenuItem';
import * as MuiTimelineOppositeContent from './MuiTimelineOppositeContent';

export type {} from './MuiButtonBase';
export type {} from './MuiFormControl';
export type {} from './MuiFormControlLabel';
export type {} from './MuiFormLabel';
export type {} from './MuiIconButton';
export type {} from './MuiInput';
export type {} from './MuiListItem';
export type {} from './MuiListItemAvatar';
export type {} from './MuiListItemButton';
export type {} from './MuiListItemIcon';
export type {} from './MuiListItemText';
export type {} from './MuiListSubheader';
export type {} from './MuiMenuItem';
export type {} from './MuiTimelineOppositeContent';

export const common: ThemeOptions['components'] = {
  ...MuiFormControlLabel,
  ...MuiFormLabel,
  ...MuiFormControl,
  ...MuiInput,
  ...MuiMenuItem,
  ...MuiButtonBase,
  ...MuiIconButton,
  ...MuiListItemAvatar,
  ...MuiListItem,
  ...MuiListItemButton,
  ...MuiListItemIcon,
  ...MuiListItemText,
  ...MuiListSubheader,
  ...MuiTimelineOppositeContent
};
